import { Component, OnInit, Inject } from '@angular/core';

import { TechModalDialogModel } from './techmodaldialog.model';
// import { TechDialogsService } from '../tech-dialogs.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'tech-techmodaldialog',
  templateUrl: './techmodaldialog.component.html',
  styleUrls: ['./techmodaldialog.component.scss'],
})
export class TechModalDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<TechModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TechModalDialogModel
  ) // private dialogService: TechDialogsService
  {}

  ngOnInit() {}

  goOut(): void {
    // this.dialogService.displayedModal = false;
    this.dialogRef.close();
  }
}
